var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiyadBankFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.76237 4.83358L13.0957 0.500244L4.42904 0.500244V4.83358L4.42904 9.16691L0.0957031 13.5002H8.76237V9.16691V4.83358Z",
    fill: "#230871"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76172 4.83358V9.16691H13.0951V0.500244L8.76172 4.83358Z",
    fill: "#08AF9B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0957031 13.4981L4.42904 9.16475V4.83142H0.0957031L0.0957031 13.4981Z",
    fill: "#08AF9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiyadBankFavicon);
export default __webpack_public_path__ + "static/media/riyad_bank_favicon.5c72f05a94deff901356ddb069bd304d.svg";
export { ForwardRef as ReactComponent };